import React, { useState } from 'react';
import ObservacaoAnexos from '../../components/ObservacaoAnexos';
import { FinField } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';

// Página de teste do ObservacaoAnexos, para o QA ver o campo sem uma tela que o use. Os controles e o value são do
// teste, em HTML sem o estilo do sistema, para não se confundirem com o campo, que é o único em .fin-pp.

const OPCOES_NO_CORPO = ['imagens', 'todos', 'nenhum'];
const VAZIO = { texto: '', anexos: [] };

// Imita o form do evento, que cancela o Enter fora do textarea para pular de campo.
const pularComEnter = (e) => {
    if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') e.preventDefault();
};

const blocoDeTeste = { border: '1px dashed #999', padding: 12, marginBottom: 16 };
const linhaDeTeste = { display: 'flex', flexWrap: 'wrap', gap: '8px 24px', alignItems: 'center' };

export default function TesteObservacao() {
    const [valor, setValor] = useState(VAZIO);
    const [anexosNoCorpo, setAnexosNoCorpo] = useState('imagens');
    const [maxAnexos, setMaxAnexos] = useState('');
    const [accept, setAccept] = useState('.jpg,.jpeg,.png,.gif,.webp,.pdf');
    const [disabled, setDisabled] = useState(false);
    const [readOnly, setReadOnly] = useState(false);
    const [semCaixa, setSemCaixa] = useState(false);
    const [dentroDeForm, setDentroDeForm] = useState(true);

    // O File some no JSON.stringify: no lugar dele vão o nome, o tipo e o tamanho.
    const valorLegivel = {
        texto: valor.texto,
        anexos: valor.anexos.map((anexo) => (anexo.arquivo instanceof File
            ? { ...anexo, arquivo: { nome: anexo.arquivo.name, tipo: anexo.arquivo.type, tamanho: anexo.arquivo.size } }
            : anexo)),
    };

    const campo = (
        <ObservacaoAnexos
            value={valor}
            onChange={setValor}
            anexosNoCorpo={anexosNoCorpo}
            maxAnexos={maxAnexos ? Number(maxAnexos) : null}
            accept={accept.trim() || null}
            disabled={disabled}
            readOnly={readOnly}
            semCaixa={semCaixa}
        />
    );

    return (
        <div style={{ padding: 24 }}>
            <h2>Teste do campo de observação (ObservacaoAnexos)</h2>
            <p>Os blocos tracejados são do teste. O campo testado é o do meio, com o estilo do sistema.</p>

            <fieldset style={blocoDeTeste}>
                <legend>Props</legend>
                <div style={linhaDeTeste}>
                    <span>
                        anexosNoCorpo:{' '}
                        {OPCOES_NO_CORPO.map((opcao) => (
                            <label key={opcao} style={{ marginRight: 8 }}>
                                <input type="radio" name="anexosNoCorpo" checked={anexosNoCorpo === opcao} onChange={() => setAnexosNoCorpo(opcao)} /> {opcao}
                            </label>
                        ))}
                    </span>
                    <label>
                        maxAnexos (vazio = sem limite):{' '}
                        <input type="number" min="1" style={{ width: 70 }} value={maxAnexos} onChange={(e) => setMaxAnexos(e.target.value)} />
                    </label>
                    <label>
                        accept (vazio = qualquer arquivo):{' '}
                        <input type="text" style={{ width: 260 }} value={accept} onChange={(e) => setAccept(e.target.value)} />
                    </label>
                    <label><input type="checkbox" checked={disabled} onChange={(e) => setDisabled(e.target.checked)} /> disabled</label>
                    <label><input type="checkbox" checked={readOnly} onChange={(e) => setReadOnly(e.target.checked)} /> readOnly</label>
                    <label><input type="checkbox" checked={semCaixa} onChange={(e) => setSemCaixa(e.target.checked)} /> semCaixa</label>
                    <label>
                        <input type="checkbox" checked={dentroDeForm} onChange={(e) => setDentroDeForm(e.target.checked)} />
                        {' '}dentro de um form que pula de campo com Enter, como o do evento
                    </label>
                    <button type="button" onClick={() => setValor(VAZIO)}>Limpar o campo</button>
                </div>
            </fieldset>

            <div className="fin-pp" style={{ marginBottom: 16 }}>
                <FinField label="Observação" full>
                    {dentroDeForm
                        ? <form onKeyDown={pularComEnter} onSubmit={(e) => e.preventDefault()}>{campo}</form>
                        : campo}
                </FinField>
            </div>

            <fieldset style={blocoDeTeste}>
                <legend>Value devolvido no onChange</legend>
                <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{JSON.stringify(valorLegivel, null, 2)}</pre>
            </fieldset>
        </div>
    );
}
